module.exports = __webpack_public_path__ + "static/media/avatar_8.33f4798c.svg";